export default __webpack_public_path__ + "static/slide0-cad19e6766b59610332400a04d65d8c9.jpg";